// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2FmE4","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__WjKpO"};